<template>
  <div class="detail_carte">
    <div>
      <h1 class="title_carte">Votre trajet à la demande</h1>

      <div class="ligne_div row">
        <div class="col_gauche col-lg-6 col-md-12">
          <div class="description_col_gauche">
            <div class="div_arret">
              <div>
                <i class="icone_curseur fas fa-map-marker-alt fa-2x"></i><span
                class="arret">{{ passage.stopName }}</span>
              </div>
            </div>
            <hr class="separator"/>

            <div v-if="prochainPassage !== null && prochainPassage.stopDepasse !== true && pasDeStopInfo !== true && arriveeIminente === false" class="texte_passage_prevu">
              <span class="texte_passage_prevu">Arrivée prévue à</span>
              <span class="heure_prevue" v-if="prochainPassage.horaireArriveEstimee !== null && prochainPassage.stopDepasse !== true">
                {{ prochainPassage.horaireArriveEstimee | filtreTemps }}
              </span>
              <span class="heure_prevue" v-else>(Calcul en cours)</span>
            </div>

            <div v-else-if="prochainPassage !== null && prochainPassage.stopDepasse !== true &&
                prochainPassage.horaireArriveEstimee !== null &&
                arriveeIminente === true && pasDeStopInfo !== true" class="bus_rate">
              <span class="bus_rate">Il est temps de retrouver votre chauffeur</span>
            </div>

            <div v-else class="bus_rate">
              <span>Ce trajet est terminé.</span>
              <div v-if="!avisSent">
                Tout s'est bien passé ? <br>
                <div class="thumbs row">
                  <div v-on:click="sendSatisfied(true)" class="col-6">
                    <a href="https://forms.gle/27aM792CZ5cMCHHi7" target="_blank" class="btn btn-light btn-lg"><i class="fas fa-thumbs-up" style="color: #4CAF50"></i></a>
                  </div>
                  <div v-on:click="sendSatisfied(false)" class="col-6">
                    <a href="https://forms.gle/27aM792CZ5cMCHHi7" target="_blank" class="btn btn-light btn-lg"><i class="fas fa-thumbs-down" style="color: #E57373"></i></a>
                  </div>
                </div>
              </div>
              <div v-else>
                Merci d'avoir donné votre avis.
              </div>
            </div>
          </div>
        </div>

        <div class="col_droite col-lg-6 col-md-12">
          <MapTAD :busReset="busReset" :coordonnees="coordonnees" :positionArret="positionArret"/>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import moment from 'moment'
import MapTAD from './MapTAD'

export default {
    name: 'Detail',
    components: {
      MapTAD
    },
    data () {
      return {
        arret: {},
        passage: {},
        prochainPassage: null,
        positions: {},
        busReset: false,
        coordonnees: null,
        positionArret: null,

        pasDeStopInfo: false,
        arriveeIminente: false,

        shapeData: {},
        shape: null,

        horairePrevuafter1hour: null,
        horaireReelafterFewhours: null,

        departBus: false,
        avisSent: false,
      }
    },

    methods: {
      departDuBus: function () {
        if (this.prochainPassage.horaireArriveReel !== null) {
          setTimeout(function () {
            this.departBus = true
          }.bind(this), 1 * 60 * 1000)
        }
      },

      chauffeurAProximite: function (heureArriveEstimee) {
        let arriveIminente = moment(String(heureArriveEstimee)).subtract(2, 'minutes')
        return (moment().isAfter(arriveIminente))
      },

      sendSatisfied: function( isSatisfied ) {

        const avis = isSatisfied === true ? 'positif' : 'negatif';

        _paq.push(['trackEvent', 'interaction', 'satisfaction_tad_' + avis, avis])

        this.avisSent = true;
      }
    },

    created () {
      this.axios
        .get('/stop-information/tad/' + this.$route.params.courseTadId + '/' + this.$route.params.reservationId)
        .then((succes) => {
          this.passage = succes.data
          this.positionArret = this.passage
        }, (error) => {
          this.pasDeStopInfo = true
          console.error('ERREUR pour stop-information', error)
        })
    },

    mounted () {
      const eventSource = new EventSource(process.env.API_URL_SSE + '/temps-reel/tad/' + this.$route.params.courseTadId + '/' + this.$route.params.reservationId)

      eventSource.onerror = (error) => {
        console.error('Erreur sur la récupération des données en temps réel', error)
        if (event.readyState === EventSource.CLOSED) {
          console.log('on passe dans le listener')
          eventSource.close()
        }
      }

      eventSource.addEventListener('prochain_passage', event => {
        console.log('Évènement prochain_passage passé : ')
        this.prochainPassage = JSON.parse(event.data)
        console.log(this.prochainPassage)
        if (this.prochainPassage.stopDepasse) {
          // On reset les markers et on stop l'eventSource
          this.busReset = true
          eventSource.close()
        } else {
          this.departDuBus()
          this.arriveeIminente = this.chauffeurAProximite(this.prochainPassage.heureArriveeEstimee)
        }
      })

      eventSource.addEventListener('position', event => {
        console.log('Évènement position passé : ')
        console.log(this.positions)
        this.busReset = false
        this.positions = JSON.parse(event.data)
        this.coordonnees = this.positions
      })

      eventSource.addEventListener('reset_prochain_passage', event => {
        console.log('Évènement RESET prochain_passage effectué')
      })

      eventSource.addEventListener('reset_vehicule_position', event => {
        console.log('Évènement RESET vehicule_position effectué')
        this.busReset = true
      })
    },

    filters: {
      filtreTemps: function (horaire) {
        if (horaire) {
          return moment(String(horaire)).format('HH') + 'h' + moment(String(horaire)).format('mm')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../../node_modules/bootstrap/scss/bootstrap";

.detail_carte {
  font-family: $titlefont;
  background-color: $firstcolor;
  min-height: 100vh;

  .title_carte {
    padding: 5rem;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
    color: white;
    @include media-breakpoint-down(sm) {
      padding: 1rem;
      font-size: 1.4rem;
    }
  }

  .ligne_div {
    margin: 0;

    .col_gauche {
      border-radius: 25px;
      background-color: white;
      display: flex;
      text-align: center;
      margin: auto auto 1rem auto;
      @include media-breakpoint-up(md) {
        max-width: 600px;
        max-height: 500px;
        min-width: 600px;
        min-height: 500px;
      }

      @include media-breakpoint-down(sm) {
        margin-left: 1rem;
        margin-right: 1rem;
        padding: 2rem 0.2rem;
      }

      @include media-breakpoint-up(sm) {
        padding: 2rem 5rem;
      }

      @include media-breakpoint-down(lg) {
        margin-bottom: 1rem;
      }

      .separator {
        border-color: $annexecolor2;
      }

      .description_col_gauche {
        margin: auto;

        .div_arret {
          .icone_curseur {
            margin-right: 10px;
            color: #76b72d;
          }

          .arret {
            text-transform: uppercase;
            color: $annexecolor2;
            font-size: 35px;
            font-weight: bold;

            @include media-breakpoint-down(sm) {
              font-size: 25px;
            }
          }
        }

        .bloc_direction {
          display: flex;
          padding: 1rem;

          .div_nom_ligne {
            margin: auto;
            display: flex;

            .id_ligne {
              font-size: 40px;
              font-weight: bold;
              width: 70px;
              height: 70px;
              margin: auto 15px auto 0;
            }

            .div_destination {
              text-align: left;
              display: grid;
              line-height: 1;

              .direction {
                text-transform: uppercase;
                font-size: 18px;
                color: $annexecolor2;
                font-weight: bold;
                margin: 0;
                @include media-breakpoint-down(sm) {
                  font-size: 18px;
                  line-height: 1.7;
                }
              }

              .destination {
                font-size: 41px;
                font-weight: bold;
                color: $annexecolor2;
                @include media-breakpoint-down(sm) {
                  font-size: 25px;
                }
              }
            }
          }
        }

        .texte_passage_prevu {
          margin: auto;
          font-family: $textfont;
          color: $firstcolor;
          line-height: 1;
          @include media-breakpoint-up(lg) {
            font-size: 35px;
          }
          @include media-breakpoint-between(md, lg) {
            font-size: 33px;
          }
          @include media-breakpoint-down(sm) {
            font-size: 25px;
          }
        }
        .bus_rate {
          font-size: 30px;
          color: $annexecolor2;
          .thumbs {
            margin-top: 10px;
            .btn {
              background-color: #ece9e9;
              font-size: 40px;
            }
          }
          @include media-breakpoint-down(sm) {
            font-size: 20px;
            .thumbs {
              .btn {
                font-size: 32px;
              }
            }
          }
          .retour_prochains_passages {
            margin-top: 1rem;
            font-size: 25px;
            background-color: $firstcolor;
            border: 2px solid $firstcolor;
            border-radius: 50px;
            @include media-breakpoint-down(sm) {
              font-size: 20px;
            }
          }
          .retour_prochains_passages:hover {
            color: $firstcolor;
            background-color: white;
          }
        }
        .bus_arret {
          font-size: 40px;
          color: $annexecolor2;
        }
        .heure_prevue {
          font-family: $titlefont;
          color: $annexecolor2;
          font-weight: bold;
          font-size: 100px;
          @include media-breakpoint-down(sm) {
            font-size: 75px;
          }
        }
      }
    }

    .col_droite {
      display: contents;
      @include media-breakpoint-down(xs) {
        margin-bottom: 1rem;
      }

      @include media-breakpoint-down(md) {
        margin: auto;
        display: flex;
      }

      .bloc_erreur {
        background-color: lightgray;
        border-radius: 25px;
        padding: 2rem 5rem;
        text-align: center;
        margin: auto auto 1rem auto;
        display: flex;
        @include media-breakpoint-up(md) {
          max-width: 600px;
          max-height: 500px;
          min-width: 600px;
          min-height: 500px;
        }

        @include media-breakpoint-down(sm) {
          max-width: 300px;
          padding: 1rem;
          height: 350px;
        }

        @include media-breakpoint-down(lg) {
          margin-bottom: 1rem;
        }
        .bloc_description_erreur {
          color: $thirdcolor;
          margin: auto;
          .load_spinner {
            display: flex;
            margin: auto auto 2rem auto;
            width: 5rem;
            height: 5rem;
          }
          .title_erreur {
            font-size: 50px;
            font-family: $titlefont;
            font-weight: bold;
          }
          .text_erreur {
            font-size: 35px;
            font-family: $textfont;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DetailCarteTAD.vue